<div class="container">
    <div class="header"></div>
    <app-header ></app-header>

    <div class="content">
      
      <router-outlet></router-outlet>
    </div>
    

    <footer class="footer">
      <!-- <app-footer ></app-footer> -->
      <div  *ngIf="!login"> 
  
        <mat-toolbar  class="sticky">
          <mat-toolbar-row fxLayout="row" fxLayoutAlign="center center"  >
              <div fxLayout="row">
                
                <button mat-button (click)="onNewJob()" >
                  <img [src]=plusimg class="iconimage"/>
                  <span class="logo"> New Job</span>
                </button>
                <button mat-button (click)="onJobStatus()">
                  <img [src]=homeimg class="iconimage">
                   <span class="logo"> Home</span>
                </button>
                
                <button  mat-button [matMenuTriggerFor]="menu">
                  <img [src]=moreimg class="iconimage">
                  <span class="logo"> More</span>
                </button>

                <mat-menu #menu="matMenu" [overlapTrigger]="false">
                  <!-- <button mat-menu-item (click)="Home()">
                    <mat-icon>home</mat-icon>
                    <span>Home</span>
                  </button> -->
                  
                  <button mat-menu-item (click)="Logout()">
                    <!-- <mat-icon>exit_to_app</mat-icon>
                    <i class='fas fa-external-link-alt'></i> -->
                    <img [src]=logoutimg class="iconimage"/>
                    <span> Logout</span>
                  </button>
                </mat-menu>
                
                
              </div>
          </mat-toolbar-row>
      </mat-toolbar>
     </div>
    
    
    </footer>
 </div>